import { Analytics } from '@gik/analytics';
import { AnalyticsEvents } from '@gik/analytics/utils/Events';
import { useGroups } from '@gik/api/inkinds/groups';
import routes from '@gik/core/routes';
import { useUserStore } from '@gik/core/store/UserStore';
import type { UIComponent } from '@gik/core/types/UI';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { navigateTo } from '@gik/core/utils/navigateTo';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { Button } from '@gik/ui-legacy/Button';
import { type MouseEvent, useCallback } from 'react';
import { InkindUserGroupsGrid } from './InkindUserGroupsGrid';

export type UserGroupsSectionProps = UIComponent;

const blockName = 'user-groups-section';

export function UserGroupsSectionComp({ ...otherProps }: UserGroupsSectionProps) {
  const bem = useBemCN(blockName);
  const userId = useUserStore(state => state.id);
  const { data: groups } = useGroups({
    userId,
    page: 1,
    per_page: 100,
  });

  const hasGroups = (groups?.length ?? 0) > 0;

  const handleCreateGroupClick = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    Analytics.fireEvent(AnalyticsEvents.GroupOnboardingClicked, { location: 'InKindProfile' });
    navigateTo(routes.groupOnboarding);
  }, []);

  return (
    <div {...bem(null, null, 'tw-flex-1')} {...otherProps}>
      <div className="flex gap-4 items-center justify-between md:justify-start">
        <h2 {...bem('title')}>Inkind Groups</h2>
        <Button
          variant="secondary"
          wide
          href={routes.groupOnboarding}
          onClick={handleCreateGroupClick}
          style={{ paddingLeft: '2rem', paddingRight: '2rem' }}
        >
          Create Group
        </Button>
      </div>
      {hasGroups && (
        <p {...bem('description')}>
          These are the Groups you belong to. They hold all InKind Pages in your group or organization.
        </p>
      )}

      <InkindUserGroupsGrid />
    </div>
  );
}

export const UserGroupsSection = withComponentErrorBoundary(UserGroupsSectionComp);
